import { useContext } from 'react';
import { PartnerContext } from './';

export const usePartner = () => {
  return useContext(PartnerContext);
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/partner/hooks.ts